import { Component, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-guidance-accordion-item',
  templateUrl: './guidance-accordion-item.component.html',
  styleUrl: './guidance-accordion-item.component.scss'
})
export class GuidanceAccordionItemComponent implements OnChanges {
  @Input() title!: string;
  @Input() bodyHtml!: string;

  public isOpen = true;
  public safeBodyHtml: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(): void {
    this.safeBodyHtml = this.sanitizer.bypassSecurityTrustHtml(this.bodyHtml);
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
  }
}
